module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global define*/\n\ndefine("collections/Vessel", [\n    \'underscore\',\n    \'backbone\',\n    \'models/Vessel\'\n], function (_, Backbone, VesselModel) {\n    \'use strict\';\n\n    var VesselCollection = Backbone.Collection.extend({\n        model: VesselModel\n    });\n\n    return VesselCollection;\n});\n';

}
return __p
}